
import About from "./About";
import Contact from "./Contact";
import Projects from "./Projects";
import Skills from "./Skills";


type Props={
  theme:boolean
}
export const HomePage = ({theme}:Props) => {
  return (
    <>
      <About theme={theme}/>
      <Projects theme={theme}/>
      <Skills theme={theme}/>
      <Contact />
    </>
  );
};
